import React, { useState } from 'react';
import Moment from 'moment-timezone';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ManageChannelIcon from '@mui/icons-material/MarkChatReadOutlined';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef((props, ref) => <Slide direction='down' ref={ref} {...props} />);

const frmtDtaInMarkRead = (date) => {
  const timeZone = Moment(date).tz('America/Los_Angeles').isDST()? ' PDT' : ' PST';
  return Moment(date).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm') + timeZone;
}
export const PrimeManageModal = ({channel, client}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [doubleConfirmation, setDoubleConfirmation] = useState(false);
  const currentTime = frmtDtaInMarkRead(Date.now());
  const clickOpenModal = () => {
    setIsOpenModal(true);
    setDoubleConfirmation(false);
  }
  const clickCloseModal = () => {
    setIsOpenModal(false);
    setDoubleConfirmation(false);
  }
  const manageChannel = async () => {
    if (doubleConfirmation === false) return setDoubleConfirmation(true);
    let channelText = `${client.user.name || client.user.id} managed this Channel @ ${currentTime}`;
    let customEventsChannel = client.channel('prime', 'custom_events');
    await customEventsChannel.watch();
    let customEvent = await customEventsChannel.sendEvent({ type: 'prime_manage', manage: { text: channelText, user_id: client.user.id, channel_id: channel.id, channel_type: channel.type }});
    if (customEvent.event && customEvent.duration) clickCloseModal();
    await customEventsChannel.stopWatching();
  };
  return (
    <>
    <IconButton size='small' color='primary' aria-label='manage channel' sx={{mr: 2}} onClick={clickOpenModal}>
      <Tooltip title='Manage channel' placement='bottom'><ManageChannelIcon /></Tooltip>
    </IconButton>
    <Dialog open={isOpenModal} TransitionComponent={Transition} onClose={clickCloseModal} aria-describedby='manage-channel-dialog'>
      <DialogTitle>{'Do you want to set this channel as managed?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id='manage-channel-dialog'>{'When a channel is set as managed, the unread count will be set to 0. Please, make sure this is intended, this action cannot be reverted.'}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color={doubleConfirmation === true ? 'warning' : 'primary'} variant='outlined' onClick={manageChannel}>{doubleConfirmation === true ? 'Are you sure?' : 'Confirm'}</Button>
        <Button variant='text' onClick={clickCloseModal}>{'Cancel'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};